import { gql } from '@apollo/client';

import { FragmentAddress, FragmentCustomer } from '../fragments/account';

export const MUTATION_CREATE_CUSTOMER_ACCESS_TOKEN = gql`
  mutation createCustomerAccessToken($email: String!, $password: String!) {
    createCustomerAccessToken(email: $email, password: $password) {
      accessToken
      refreshToken
      expiresAt
    }
  }
`;

export const MUTATION_RENEW_CUSTOMER_ACCESS_TOKEN = gql`
  mutation RenewCustomerAccessToken($customerRefreshToken: String!) {
    renewCustomerAccessToken(customerRefreshToken: $customerRefreshToken) {
      accessToken
      refreshToken
      expiresAt
    }
  }
`;

export const MUTATION_CREATE_CUSTOMER = gql`
  mutation CreateCustomer($input: CreateCustomerInput) {
    createCustomer(input: $input) {
      updatedAt
      createdAt
      salutation
      email
      lastName
      firstName
      id
    }
  }
`;

export const MUTATION_CONFIRM_CUSTOMER = gql`
  mutation ConfirmCustomer($registrationKey: String!) {
    confirmCustomer(registrationKey: $registrationKey)
  }
`;

export const MUTATION_CUSTOMER_RECOVER = gql`
  mutation CustomerRecover($email: String!) {
    customerRecover(email: $email)
  }
`;

export const MUTATION_CUSTOMER_RESET = gql`
  mutation CustomerReset(
    $passwordHash: String!
    $password: String!
    $passwordConfirm: String!
  ) {
    customerReset(
      passwordHash: $passwordHash
      password: $password
      passwordConfirm: $passwordConfirm
    )
  }
`;

export const MUTATION_ADD_CUSTOMER_ADDRESS = gql`
  mutation AddCustomerAddress($input: CustomerAddressInput!) {
    addCustomerAddress(input: $input) {
      ...FragmentAddress
    }
  }
  ${FragmentAddress}
`;

export const MUTATION_UPDATE_CUSTOMER_ADDRESS = gql`
  mutation Mutation(
    $customerAddressId: String!
    $input: CustomerAddressInput!
  ) {
    updateCustomerAddress(
      customerAddressId: $customerAddressId
      input: $input
    ) {
      ...FragmentAddress
    }
  }
  ${FragmentAddress}
`;

export const MUTATION_DELETE_CUSTOMER_ADDRESS = gql`
  mutation Mutation($deleteCustomerAddressCustomerAddressId: String!) {
    deleteCustomerAddress(
      customerAddressId: $deleteCustomerAddressCustomerAddressId
    )
  }
`;

export const MUTATION_UPDATE_PASSWORD = gql`
  mutation UpdateCustomerPassword($input: UpdateCustomerPasswordInput) {
    updateCustomerPassword(input: $input)
  }
`;

export const MUTATION_UPDATE_CUSTOMER = gql`
  mutation UpdateCustomer($input: UpdateCustomerInput) {
    updateCustomer(input: $input) {
      ...FragmentCustomer
    }
  }
  ${FragmentCustomer}
`;

export const MUTATION_DELETE_CUSTOMER = gql`
  mutation DeleteCustomer($userId: String!) {
    deleteCustomer(userId: $userId)
  }
`;

export const RESEND_ACTIVATION_TOKEN = gql`
  mutation ResendCustomerActivationToken($input: String) {
    resendCustomerActivationToken(input: $input)
  }
`;
